<template>
    <div>
        <webix-ui :config="ui" v-model="orders"></webix-ui>
        <div id="flaggedOrdersPaging"></div>
    </div>
</template>

<script>
import { orderMethods, orderComputed, adminComputed } from "@/state/helpers";

export default {
    data: () => ({
        ui: {
            id: "flaggedOrdersTable",
            view: "datatable",
            css: "datatableUsers webix_header_border webix_data_border",
            autoheight: true,
            minHeight: 60,
            minColumnWidth: 120,
            rowHeight: 40,
            scrollY: false,
            scrollX: true,
            resizeColumn: true,
            select: false,
            pager: {
                template: "{common.prev()} {common.pages()} {common.next()}",
                container: "flaggedOrdersPaging",
                css: { width: "100% !important" },
                size: 15,
                group: 5,
            },
            columns: [
                {
                    id: "actions",
                    header: "Actions",
                    adjust: true,
                    //eslint-disable-next-line
                    template: function () {
                        return '<div class="tableIcons"><i class="mdi mdi-eye viewAction"></i></div>';
                    },
                },
                {
                    id: "order_no",
                    header: ["Order Number", { content: "textFilter" }],
                    tooltip: false,
                    adjust: true,
                },
                {
                    id: "flag_notes",
                    header: ["Flag Reason", { content: "textFilter" }],
                    width: 200,
                },
                {
                    id: "flag_resolved",
                    header: ["Status", { content: "selectFilter" }],
                    width: 110,
                    //eslint-disable-next-line
                    template: function (obj) {
                        if (obj.flag_resolved) {
                            return '<span class="badge badge-success">Resolved</span>';
                        }
                        return '<span class="badge badge-danger">Open</span>';
                    },
                },
                {
                    id: "resolved_by_name",
                    header: ["Resolved By", { content: "textFilter" }],
                    width: 130,
                },
                {
                    id: "flag_resolved_at",
                    header: ["Resolved At", { content: "textFilter" }],
                    width: 150,
                },
                {
                    id: "status_name",
                    header: ["Order Status", { content: "selectFilter" }],
                    adjust: true,
                },
                {
                    id: "order_source",
                    header: ["Source", { content: "selectFilter" }],
                    width: 100,
                    //eslint-disable-next-line
                    template: function (obj) {
                        if (obj.order_source === "pos") {
                            return '<span class="badge badge-info">POS</span>';
                        }
                        return '<span class="badge badge-primary">Online</span>';
                    },
                },
                {
                    id: "order_branch_name",
                    header: ["Branch", { content: "selectFilter" }],
                    tooltip: false,
                    adjust: true,
                },
                {
                    id: "client_name",
                    header: ["Member Name", { content: "textFilter" }],
                    adjust: true,
                },
                {
                    id: "created_date",
                    header: ["Created Date", { content: "textFilter" }],
                    tooltip: false,
                    adjust: true,
                },
            ],
            on: {},
            onClick: {
                //eslint-disable-next-line
                viewAction: function (id, e) {
                    let el = this.$scope.$parent;
                    let idForUrl = e.row;

                    el.setSelectedOrder(e.row);

                    el.$router.push({
                        path: `/orders/view/order/${idForUrl}`,
                    });
                },
            },
        },
    }),
    computed: {
        ...adminComputed,
        ...orderComputed,
        orders() {
            return this.flagged_orders;
        },
    },
    methods: {
        ...orderMethods,
    },
};
</script>
